import React from "react";
import { Button, Form, FormGroup, Input, Col, Row } from "reactstrap";
import "./Contact.css";

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="Contact">
        <div className="Triangle"></div>
        <div className="container">
          <h1 className="py-5 m-0">CONTACT</h1>
          <a href="/#"> Have a question or want us to work together?</a>

          <Row>
            <Col md="6">
              <div className="py-3 container">
                <Form>
                  <FormGroup>
                    <Input
                      type="text"
                      id="name"
                      name="full-name"
                      placeholder="Enter Name"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter Email"
                    />
                  </FormGroup>
                  <FormGroup>
                    <textarea
                      rows="3"
                      id="message"
                      placeholder="Enter Message"
                      className="form-control"
                    ></textarea>
                  </FormGroup>
                  <Button>Submit</Button>
                </Form>
              </div>
            </Col>
            <Col md="6" className="social">
              <Row>
                <Col>
                  <a href="https://github.com/wambuguedison">
                    <i className="fas fa-phone"></i>
                  </a>
                </Col>
                <Col>
                  <a href="wa.me">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </Col>
                <Col>
                  <a href="mailto:wambuguedison@gmail.com">
                    <i className="far fa-envelope"></i>
                  </a>
                </Col>
                <Col>
                  <a href="https://github.com/wambuguedison">
                    <i className="fab fa-github-alt"></i>
                  </a>
                </Col>

                <Col>
                  <a href="https://linkedin.com/in/wambuguedison">
                    <i className="fab fa-linkedin"></i>
                  </a>
                </Col>
                <Col>
                  <a href="https://dev.to/wambuguedison">
                    <i className="fab fa-dev"></i>
                  </a>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Contact;
